// Javascript for all non-/app pages
import 'wealthbar';

angular.module('wbIndex', ['wealthbar'])
.config([
  '$locationProvider', 'd3localeProvider',
  function($locationProvider, d3localeProvider, config) {
    $locationProvider.html5Mode({ enabled: true, requireBase: false })
    d3localeProvider.setLocales({
      "en-us": require('../../node_modules/angular_d3/angularD3/locale/en-US'),
      "fr-ca": require('../../node_modules/angular_d3/angularD3/locale/fr-CA'),
    })
  }
])
.run(['$rootScope', 'users', 'locale', function($rootScope, users, locale) {
  users.checkSignin()
  locale.setLanguage(locale.getCurrentLanguage())
}])

angular.bootstrap(document.body, ['wbIndex'])
